import(/* webpackMode: "eager", webpackExports: ["Client"] */ "/codebuild/output/src4041000233/src/next-app/app/(unauthenticated)/login/client.tsx");
